import { faSubtitles } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Stack, Typography } from '@mui/material';
import { AppGlobalClassKeys } from 'app/appGlobalStyles';
import { MprcContainer, MprcLink } from 'components';
import { FeedItemDto } from 'generated/CoreApi_v1';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CardOwnPropsOptions } from 'views/knowledge/components/card';
import { VideoTranscriptionDrawer, VideoTranscriptionResults, VideoTranscriptionSearchField } from 'views/knowledge/components/card/actions/VideoTranscriptionDrawer';
import { FeedCustomEventProps, subscribe, unsubscribe } from 'views/knowledge/feed/FeedEvents';

////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    publication: FeedItemDto;
}

////////////////////////////////////////////////////////////////////////////////

export const TranscriptionBox: React.FC<IProps> = ({ publication }) => {

    const { t } = useTranslation("knowledge");

    const [searchText, setSearchText] = useState<string>("");
    const [searching, setSearching] = useState<boolean>(false);
    const [currentAttachId, setCurrentAttachId] = useState<string | undefined>(publication.presentation?.orderedItems != undefined ? publication.presentation?.orderedItems[0] : undefined);
    const [viewFullTranscription, setViewFullTranscription] = useState<boolean>(false);

    const searchTextRef = useRef<HTMLInputElement | undefined>(undefined);

    ////////////////////////////////////////////////////////////////////////////////////////////////

    ///
    const handleAttachChange = (e: FeedCustomEventProps) => {
        const cardOwnProps: Partial<CardOwnPropsOptions> = JSON.parse(e.detail ?? "");
        if (cardOwnProps != undefined && cardOwnProps.publicationId == publication.publicationId) {
            setCurrentAttachId(cardOwnProps.presentation?.currentAttachId ?? undefined);
        }
    };

    ////////////////////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        subscribe("CardOwnPropsChanged", (e) => handleAttachChange(e));

        return () => {
            unsubscribe("CardOwnPropsChanged", (e) => handleAttachChange(e));
        };
    }, []);

    if (currentAttachId == undefined || !publication.attachs)
        return null;

    const attach = publication.attachs.find(a => a.attachId == currentAttachId);
    if (attach == null || !attach.hasTranscription)
        return null;

    return (
        <>
            <MprcContainer margin="dense">
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="h3">
                        {t("Publication.ContentPage.TranscriptionSubtitle")}
                    </Typography>
                    <MprcLink onClick={() => setViewFullTranscription(true)} title={t("Publication.ContentPage.ViewFullTranscription")}>
                        <FontAwesomeIcon icon={faSubtitles} />
                    </MprcLink>
                </Stack>
            </MprcContainer>

            <MprcContainer margin={searchText.length > 0 ? "dense" : "none"}>
                <VideoTranscriptionSearchField
                    inputRef={searchTextRef}
                    autoFocus={false}
                    onConfirm={(value) => {
                        setSearchText(value);
                        setSearching(true);
                    }}
                />
            </MprcContainer>

            {searchText.length > 0 &&
                <Box sx={{ maxHeight: "50vh", overflow: "auto" }} className={AppGlobalClassKeys.thinScrollbar}>
                    <VideoTranscriptionResults
                        attachId={currentAttachId}
                        searchText={searchText}
                        searching={searching}
                        onCompleteSearch={() => setSearching(false)}
                    />
                </Box>
            }


            {viewFullTranscription &&
                <VideoTranscriptionDrawer
                    attachId={currentAttachId!}
                    title={attach.fileTitle ?? attach.fileDescription ?? publication.title}
                    onClose={() => setViewFullTranscription(false)}
                />
            }
        </>
    );
};
